// extracted by mini-css-extract-plugin
export default {"root":"ApplyingEditsBadge_root__gH5GE","appear":"ApplyingEditsBadge_appear__5xH24"};